'use strict';

var Base64 = require('spotify-crypto/base64');

/**
 * A context creator for clientId.
 *
 * Note that the client id needs to be sent to the server as a hex bytestring.
 *
 * @param {string} clientId   The clientId to be attached to each event
 * @return {function}   The function that attaches the clientId to every event
 */
function createClientId(clientId) {
  if (!clientId || (clientId.length % 2) !== 0) {
    throw new TypeError('Invalid clientId value.');
  }
  var parts = clientId.match(/[0-9a-f]{2}?/g);
  if (!parts || !parts.length) {
    throw new TypeError('Invalid clientId value.');
  }
  var bytestr = String.fromCharCode.apply(null, parts.map(function(i) {
    return parseInt(i, 16);
  }));
  var encoded = Base64.encode(bytestr);
  return function() {
    return {
      name: 'context_client_id',
      data: { value: encoded }
    };
  };
}

module.exports = createClientId;
